<template>
  <div @click="open">
    <vs-card class="my-2" actionable>
      <div class="flex flex-row">
        <p class="text-sm article-title">
          {{ article.title }}
        </p>
      </div>
      <div class=" mt-1 flex flex-row">
        <p class="article-date">
          <span class=" mr-1 text-sm font-semibold">Published: </span>
          {{ article.date }}
        </p>
      </div>
    </vs-card>
    <vs-popup class="holamundo" :title="article.title" :active.sync="popupOpen">
      <p v-if="article.creator" class="mb-2">
        <span class="text-base font-semibold">Authors: </span
        >{{ article.creator }}
      </p>
      <p class="mb-2">
        <span class="text-base font-semibold">Date: </span>{{ article.date }}
      </p>
      <p class="mb-2">
        <span class="text-base font-semibold">Snippet: </span
        >{{ article.contentSnippet }}
      </p>
      <div class=" flex flex-row justify-center">
        <vs-button
          v-if="isPodcast"
          :href="article.link"
          target="_blank"
          class="mt-4"
          color="primary"
          type="filled"
          >Listen to podcast</vs-button
        >
        <vs-button
          v-else
          :href="article.link"
          target="_blank"
          class="mt-4"
          color="primary"
          type="filled"
          >View full resource</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: "RssCard",
  props: {
    article: {
      type: Object,
      default() {
        return {};
      }
    },
    isPodcast: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      popupOpen: false
    };
  },
  methods: {
    open() {
      this.popupOpen = true;
    }
  }
};
</script>
